<button class="collapse-btn" mat-icon-button (click)="emitButtonClicked()">
  <mat-icon>{{ drawerOpened ? 'chevron_left' : 'chevron_right' }}</mat-icon>
</button>
